const sameArrayUnordered = (a = [], b = []) => {
  const as = [...a].sort()
  const bs = [...b].sort()
  return as.length === bs.length && as.every((v, i) => v === bs[i])
}

module.exports = {
  sameArrayUnordered,
}
